// extracted by mini-css-extract-plugin
export default {"button":"ResultPage_button__Nr7Tx"};